/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
var GridTypesGenerator_1 = require("./GridTypesGenerator");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Grid.css'); }
exports.GridRow = function (_a) {
    var children = _a.children, _b = _a.fluid, fluid = _b === void 0 ? false : _b, className = _a.className, _c = _a.centerVertical, centerVertical = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: classnames("m-row", [
            fluid && "m-row-fluid",
            centerVertical && "m-row-centerVertical",
            className
        ]) }, children));
};
exports.GridRow.propTypes = {
    fluid: PropTypes.bool,
    centerVertical: PropTypes.bool
};
exports.GridRow.displayName = "GridRow";
var buildColClassNames = function (props) {
    return Object.keys(props).map(function (key) { return "m-col-" + key; });
};
exports.GridCol = function (_a // eslint-disable-line react/no-multi-comp
) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"] // eslint-disable-line react/no-multi-comp
    );
    return React.createElement("div", { className: classnames(buildColClassNames(props)) }, children);
};
exports.GridCol.propTypes = GridTypesGenerator_1.generateColumnProps().reduce(function (propTypes, propName) {
    var _a;
    return (tslib_1.__assign((_a = {}, _a[propName] = PropTypes.bool, _a), propTypes));
}, {});
exports.GridCol.displayName = "GridCol";